document.addEventListener('DOMContentLoaded', function () {
  var countdownEls = document.querySelectorAll('.flash-countdown');

  countdownEls.forEach(function (el) {
    var targetDateStr = el.getAttribute('data-countdown-target');
    var targetDate = new Date(targetDateStr).getTime();

    if (isNaN(targetDate)) return;

    var daysEl = el.querySelector('[data-unit="days"]');
    var hoursEl = el.querySelector('[data-unit="hours"]');
    var minsEl = el.querySelector('[data-unit="mins"]');
    var secsEl = el.querySelector('[data-unit="secs"]');

    function pad(num) {
      return String(num).padStart(2, '0');
    }

    function update() {
      var now = new Date().getTime();
      var distance = targetDate - now;

      if (distance < 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minsEl.textContent = '00';
        secsEl.textContent = '00';
        return;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var secs = Math.floor((distance % (1000 * 60)) / 1000);

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minsEl.textContent = pad(mins);
      secsEl.textContent = pad(secs);
    }

    update();
    setInterval(update, 1000);
  });
});